function Alerts({
  projectAlerts,
  editarAlerta,
  eliminarAlerta
}) {

  return (

    <div style={styles.tableBox}>

      <h2>
        Alertas Territoriales
      </h2>

      <table style={styles.table}>

        <thead>

          <tr>
            <th style={styles.th}>Título</th>
            <th style={styles.th}>Nivel</th>
            <th style={styles.th}>Actor</th>
            <th style={styles.th}>Fecha</th>
            <th style={styles.th}>Estado</th>
            <th style={styles.th}>Acciones</th>
          </tr>

        </thead>

        <tbody>

          {projectAlerts.map((alerta) => (

            <tr key={alerta.id}>

              <td style={styles.td}>
                {alerta.titulo}
              </td>

              <td style={styles.td}>
                {alerta.nivel}
              </td>

              <td style={styles.td}>
                {alerta.actor}
              </td>

              <td style={styles.td}>
                {alerta.fecha}
              </td>

              <td style={styles.td}>
                {alerta.estado}
              </td>

              <td style={styles.td}>

                <button
                  style={styles.editButton}
                  onClick={() => editarAlerta(alerta)}
                >
                  Editar
                </button>

                <button
                  style={styles.deleteButton}
                  onClick={() => eliminarAlerta(alerta.id)}
                >
                  Eliminar
                </button>

              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>
  );
}

const styles = {

  tableBox: {
    background: 'white',
    padding: '30px',
    borderRadius: '14px',
    marginBottom: '40px',
    boxShadow: '0 8px 25px rgba(0,0,0,0.08)',
    overflowX: 'auto'
  },

  table: {
    width: '100%',
    marginTop: '20px',
    borderCollapse: 'collapse'
  },

  th: {
    textAlign: 'left',
    padding: '12px',
    borderBottom: '2px solid #ddd'
  },

  td: {
    padding: '12px',
    borderBottom: '1px solid #eee'
  },

  editButton: {
    padding: '10px 14px',
    background: '#0b5ed7',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    marginRight: '8px'
  },

  deleteButton: {
    padding: '10px 14px',
    background: '#b42318',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer'
  }

};

export default Alerts;